import React, { useState } from 'react';
import { Download, X, Bell, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { usePWA } from '../hooks/usePWA';

export const PWAInstallPrompt = () => {
  const {
    isInstalled,
    isSupported,
    canInstall,
    installPWA,
    requestNotificationPermission
  } = usePWA();

  const [showPrompt, setShowPrompt] = useState(true);
  const [notificationsEnabled, setNotificationsEnabled] = useState(
    Notification.permission === 'granted'
  );

  const handleInstall = async () => {
    const installed = await installPWA();
    if (installed) {
      setShowPrompt(false);
    }
  };

  const handleEnableNotifications = async () => {
    const granted = await requestNotificationPermission();
    setNotificationsEnabled(granted);
    
    if (granted) {
      // Show test notification
      new Notification('SG Cabs Admin', {
        body: 'Notifications enabled! You will be alerted for new bookings.',
        icon: '/sg-cabs-logo.png'
      });
    }
  };

  // Don't show if already installed or not supported
  if (isInstalled || !isSupported || !showPrompt) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white p-4 shadow-lg">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <Download className="w-8 h-8 flex-shrink-0" />
            <div>
              <h3 className="font-bold text-lg">Install SG Cabs Admin App</h3>
              <p className="text-sm text-blue-100">
                Get faster access, offline support, and push notifications
              </p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            {!notificationsEnabled && (
              <Button
                onClick={handleEnableNotifications}
                data-testid="enable-alerts-btn"
                className="bg-white text-blue-600 hover:bg-blue-50"
              >
                <Bell className="w-4 h-4 mr-2" />
                Enable Alerts
              </Button>
            )}
            
            {notificationsEnabled && (
              <div className="flex items-center text-green-200">
                <CheckCircle className="w-4 h-4 mr-2" />
                <span className="text-sm">Alerts enabled</span>
              </div>
            )}
            
            {canInstall && (
              <Button
                onClick={handleInstall}
                className="bg-yellow-400 text-black hover:bg-yellow-500 font-semibold"
              >
                <Download className="w-4 h-4 mr-2" />
                Install App
              </Button>
            )}
            
            <button
              onClick={() => setShowPrompt(false)}
              className="text-white hover:text-blue-200 p-2"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
